import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vote',
})
export class VotePipe implements PipeTransform {
  transform(value: number) {
    if (Number.isInteger(value) || (value ^ 0) === value) {
      return value.toFixed(1);
    }
    return value;
  }
}
